import { createReducer, on } from '@ngrx/store';
import * as CountryActions from '../../actions/master-data/country.actions';
import { CountryState } from '../../states/master-data/country.state';

export const initialState: CountryState = {loading: false, countries: [], error: null, successMessage: ''};

export const countryReducer = createReducer(
    initialState,
    on(CountryActions.loadCountries, (state) => ({ ...state, loading: true, successMessage: '', error: null })),
    on(CountryActions.loadCountriesSuccess, (state, {countries}) => ({ ...state, loading: false, countries })),
    on(CountryActions.addCountry, (state, { country }) => ({...state, countries: [...state.countries, country]})),
    on(CountryActions.addCountrySuccess, (state, { message }) => ({
        ...state,
        successMessage: message,
        error: null
    })),
    on(CountryActions.updateCountry, (state, {country}) => ({...state, countries: state.countries.map(c => c.id === country.id ? country : c)})),
    on (CountryActions.updateCountrySuccess, (state, { message }) => ({
        ...state,
        successMessage: message ?? 'Country updated successfully'
    })),
    on(CountryActions.deleteCountry, (state, {id}) => ({...state, regions: state.countries.filter(c => c.id !== id)})),
    on(CountryActions.deleteCountrySuccess, (state, { message }) => ({
        ...state,
        successMessage: message ?? 'Country deleted successfully'
    })),
    on(CountryActions.loadCountriesFailure, (state, { error }) => ({ ...state, loading: false, error })),
);